'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dCredential$002dName$0024$0024anon$002448 from "./presto.types$-Credential-Name$$anon$48.js";
import * as $j_presto$002etypes$0024$002dCredential$002dName$0024$0024anon$002449 from "./presto.types$-Credential-Name$$anon$49.js";
var $p;
/** @constructor */
function $c_Lpresto_types$CredentialName$() {
  this.c4H = null;
  this.c4I = false;
  this.c4F = null;
  this.c4G = false;
  this.c4L = null;
  this.c4M = false;
  this.c4J = null;
  this.c4K = false;
  this.c4N = null;
  this.c4O = false;
}
export { $c_Lpresto_types$CredentialName$ as $c_Lpresto_types$CredentialName$ };
$p = $c_Lpresto_types$CredentialName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CredentialName$;
/** @constructor */
function $h_Lpresto_types$CredentialName$() {
}
export { $h_Lpresto_types$CredentialName$ as $h_Lpresto_types$CredentialName$ };
$h_Lpresto_types$CredentialName$.prototype = $p;
$p.cs1 = (function() {
  if ((!this.c4I)) {
    this.c4H = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD;
    this.c4I = true;
  }
  return this.c4H;
});
$p.gl = (function() {
  if ((!this.c4G)) {
    this.c4F = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c4G = true;
  }
  return this.c4F;
});
$p.adD = (function() {
  if ((!this.c4M)) {
    this.c4L = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c4M = true;
  }
  return this.c4L;
});
$p.adB = (function() {
  if ((!this.c4K)) {
    this.c4J = new $j_presto$002etypes$0024$002dCredential$002dName$0024$0024anon$002448.$c_Lpresto_types$CredentialName$$anon$48(this);
    this.c4K = true;
  }
  return this.c4J;
});
$p.GL = (function() {
  if ((!this.c4O)) {
    this.c4N = new $j_presto$002etypes$0024$002dCredential$002dName$0024$0024anon$002449.$c_Lpresto_types$CredentialName$$anon$49(this);
    this.c4O = true;
  }
  return this.c4N;
});
var $d_Lpresto_types$CredentialName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CredentialName$, "presto.types$CredentialName$", ({
  YV: 1,
  D: 1
}));
export { $d_Lpresto_types$CredentialName$ as $d_Lpresto_types$CredentialName$ };
var $n_Lpresto_types$CredentialName$;
function $m_Lpresto_types$CredentialName$() {
  if ((!$n_Lpresto_types$CredentialName$)) {
    $n_Lpresto_types$CredentialName$ = new $c_Lpresto_types$CredentialName$();
  }
  return $n_Lpresto_types$CredentialName$;
}
export { $m_Lpresto_types$CredentialName$ as $m_Lpresto_types$CredentialName$ };
//# sourceMappingURL=presto.types$-Credential-Name$.js.map
